import { ToggleButtonGroup } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import Context from "../context";
import ToggleItem from "./DemoToggle/ToggleItem";

// ----------------------------------------------------------------------

export const ShowTypeToggle = () => {
	const { actions, state } = useContext(Context);

	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	return (
		<ToggleButtonGroup
			aria-label='Platform'
			color='primary'
			exclusive
			fullWidth={isMobile}
			onChange={(_e, value) => actions.onChangeShowType(value)}
			size='small'
			value={state.showType}
		>
			<ToggleItem
				icon='material-symbols:table'
				title={translate("result_demo.list")}
				value={"NO_AGREGATED"}
			/>
			<ToggleItem
				icon='mingcute:stock-line'
				title={translate("result_demo.by_type")}
				value={"AGREGATED"}
			/>
			{/* <ToggleItem icon='iconoir:wallet-solid' title='Por cartera' value={"PORTFOLIO"} /> */}
		</ToggleButtonGroup>
	);
};

export default ShowTypeToggle;
